// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"NavbarLogo_logoLink__Hs8nR","logoButton":"NavbarLogo_logoButton__b0Asn","logoImage":"NavbarLogo_logoImage__o3tmW"};